var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3637 13.3637C13.7152 13.0122 14.285 13.0122 14.6365 13.3637L23.3865 22.1137C23.738 22.4652 23.738 23.035 23.3865 23.3865C23.035 23.738 22.4652 23.738 22.1137 23.3865L14.0001 15.2729L5.88649 23.3865C5.53502 23.738 4.96517 23.738 4.6137 23.3865C4.26223 23.035 4.26223 22.4652 4.6137 22.1137L13.3637 13.3637Z",
    fill: "#383733"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3637 4.6137C13.7152 4.26223 14.285 4.26223 14.6365 4.6137L23.3865 13.3637C23.738 13.7152 23.738 14.285 23.3865 14.6365C23.035 14.988 22.4652 14.988 22.1137 14.6365L14.0001 6.52289L5.88649 14.6365C5.53502 14.988 4.96517 14.988 4.6137 14.6365C4.26223 14.285 4.26223 13.7152 4.6137 13.3637L13.3637 4.6137Z",
    fill: "#383733"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/up.393e26f5620910001e9e9bb4664dd59a.svg";
export { ForwardRef as ReactComponent };